// extracted by mini-css-extract-plugin
module.exports = {"linkList":"ConsumerNav_linkList__uhDqu","item":"ConsumerNav_item__ALF6S"};